export function GerarToken() {
    // Prefixo fixo
    const prefixo = 'CB';
    
    const time = new Date().getHours() + '' + new Date().getMinutes();
    
    // Gerar parte aleatória com 3 caracteres
    const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numeros = '0123456789';
    let parteAleatoria = '';
    
    // Adicionando 3 caracteres aleatórios (letras ou números)
    for (let i = 0; i < 3; i++) {
        const randomChar = Math.random() < 0.5 
            ? letras.charAt(Math.floor(Math.random() * letras.length)) 
            : numeros.charAt(Math.floor(Math.random() * numeros.length));
        parteAleatoria += randomChar;
    }

    // Combinar tudo no formato desejado
    const token = `${prefixo}${time}${parteAleatoria}`;

    return token;
}
